export default __webpack_public_path__ + "static/logo-experiment-e44571e31fb9272db5cc1f68563948df.svg";